import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const chatRole = (user) => {
    if (user?.role) return user.role;
    try {
        return JSON.parse(localStorage.getItem('userData') || '{}')?.role;
    } catch (err) {
        return null;
    }
};

const DoctorChatGuard = ({ children }) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const role = chatRole(user);

    useEffect(() => {
        if (role && role !== 'doctor') {
            navigate('/main-panel', { replace: true });
        }
    }, [navigate, role]);

    if (role && role !== 'doctor') return null;
    return children;
};

DoctorChatGuard.propTypes = {
    children: PropTypes.node
};

export default DoctorChatGuard;
